// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Oppf","content":"styles_content__2cZoN","checkbox":"styles_checkbox__1SoxZ","checkboxLabel":"styles_checkboxLabel__2ZEXu"};